import React from "react";

const NoPage = () => {
  return (
    <div className="dateAdded">
      <h1>
        This <span>URL(link)</span> you are trying does not exist please <span>check and verify url</span>
      </h1>
    </div>
  );
};

export default NoPage;
